//@ts-nocheck
import React from 'react';
import { Table, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Spinner from 'components/spinner';
import { firstLetterToUpperCase } from 'services/utils/string';

const OrdersTable = ({ orders, loading, onOrderClick, onDeleteOrder }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      oczekuje: { variant: 'info', text: 'Oczekujące' },
      ['w realizacji']: { variant: 'primary', text: 'W realizacji' },
      odebrano: { variant: 'success', text: 'Odebrane' },
    };
    const config = statusConfig[status] || {
      variant: 'secondary',
      text: status,
    };
    return (
      <Badge bg={config.variant}>
        {firstLetterToUpperCase(config.text)}
      </Badge>
    );
  };

  const calculateTotalItems = (items) => {
    return items.reduce((total, item) => total + item.quantity, 0);
  };

  const calculateTotalValue = (items) => {
    return items.reduce(
      (total, item) => total + item.quantity * item.unitPrice,
      0,
    );
  };

  const canDeleteOrder = (status) => {
    return status === 'oczekuje' || status === 'w realizacji';
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center my-4">
        <Spinner />
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="text-center my-4">
        <p className="text-muted">Brak zamówień do wyświetlenia</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Nr zamówienia</th>
            <th>Data utworzenia</th>
            <th>Producent</th>
            <th>Status</th>
            <th>Ilość pozycji</th>
            <th>Wartość całkowita</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order._id}>
              <td>
                <strong>{order.orderNumber || order.number}</strong>
              </td>
              <td>{formatDate(order.createdAt)}</td>
              <td>
                {typeof order.producer === 'object'
                  ? order.producer?.name
                  : order.producer}
              </td>
              <td>{getStatusBadge(order.status)}</td>
              <td>
                <span>{calculateTotalItems(order.items)} szt.</span>
              </td>
              <td>
                <strong>
                  {calculateTotalValue(order.items).toFixed(2)} zł
                </strong>
              </td>
              <td>
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => onOrderClick(order._id)}
                  >
                    Szczegóły
                  </Button>
                  {canDeleteOrder(order.status) && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() =>
                        onDeleteOrder(order._id, order.number)
                      }
                      title="Usuń zamówienie"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default OrdersTable;
